import { EffectCallback, useEffect } from "react";

export function useOnce(cb: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(cb, []);
}
